import { render } from "./ManajemenTable.vue?vue&type=template&id=4ff12e16"
import script from "./ManajemenTable.vue?vue&type=script&lang=js"
export * from "./ManajemenTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__